import { createSelector } from "@ngrx/store";
import {
  GET_ADVANCED_SETTINGS_SUCCESS,
  GET_COMPANY_SETTINGS_SUCCESS,
  GET_EMPLOYEE_SETTINGS_SUCCESS,
  GET_PREDEFINED_EMPLOYEE_SETTINGS_SUCCESS,
  GET_BILLING_SETTINGS_SUCCESS,
  GET_INTEGRATION_SETTINGS_SUCCESS,
  CHANGE_EMPLOYEE_SETTINGS_SUCCESS,
  CHANGE_ADVANCED_SETTINGS_SUCCESS,
  CHANGE_COMPANY_SETTINGS_SUCCESS,
  SettingsActions,
} from "./settings.actions";
import {
  SettingsState,
  AdvancedSettings,
  EmployeeSetting,
} from "./settings.interface";

export const initialState: SettingsState = {
  employeeSettings: [],
  companySettings: null,
  predefinedEmployeeSettings: [],
  advancedSettings: null,
  billingSettings: null,
  integrationSettings: null,
};

export function settingsReducer(
  state: SettingsState = initialState,
  action: SettingsActions,
): SettingsState {
  switch (action.type) {
    case GET_EMPLOYEE_SETTINGS_SUCCESS:
      return {
        ...state,
        employeeSettings: action.payload,
      };
    case CHANGE_EMPLOYEE_SETTINGS_SUCCESS:
      return {
        ...state,
        employeeSettings: Array.isArray(action.payload)
          ? (action.payload as EmployeeSetting[])
          : state.employeeSettings,
      };
    case GET_COMPANY_SETTINGS_SUCCESS:
      return {
        ...state,
        companySettings: action.payload,
      };
    case CHANGE_COMPANY_SETTINGS_SUCCESS:
      return state;
    case GET_PREDEFINED_EMPLOYEE_SETTINGS_SUCCESS:
      return {
        ...state,
        predefinedEmployeeSettings: action.payload,
      };
    case GET_ADVANCED_SETTINGS_SUCCESS:
      return {
        ...state,
        advancedSettings: action.payload,
      };
    case CHANGE_ADVANCED_SETTINGS_SUCCESS:
      return {
        ...state,
        advancedSettings:
          action.payload &&
          typeof action.payload === "object" &&
          !Array.isArray(action.payload)
            ? (action.payload as AdvancedSettings)
            : state.advancedSettings,
      };
    case GET_BILLING_SETTINGS_SUCCESS:
      return {
        ...state,
        billingSettings: action.payload,
      };
    case GET_INTEGRATION_SETTINGS_SUCCESS:
      return {
        ...state,
        integrationSettings: action.payload,
      };
    default: {
      return state;
    }
  }
}

export const getSettingsState = (state: { settings: SettingsState }) =>
  state.settings;
export const getEmployeeSettingsState = (state: {
  employeeSettings: SettingsState["employeeSettings"];
}) => state.employeeSettings;
export const getPredefinedEmployeeSettingsState = (state: {
  predefinedEmployeeSettings: SettingsState["predefinedEmployeeSettings"];
}) => state.predefinedEmployeeSettings;
export const getCompanySettingsState = (state: {
  companySettings: SettingsState["companySettings"];
}) => state.companySettings;
export const getAdvancedSettingsState = (state: {
  advancedSettings: SettingsState["advancedSettings"];
}) => state.advancedSettings;
export const getBillingSettingsState = (state: {
  billingSettings: SettingsState["billingSettings"];
}) => state.billingSettings;
export const getIntegrationSettings = (state: {
  integrationSettings: SettingsState["integrationSettings"];
}) => state.integrationSettings;

export const getEmployeeSettingsSelector = createSelector(
  getSettingsState,
  getEmployeeSettingsState,
);
export const getPredefinedEmployeeSettingsSelector = createSelector(
  getSettingsState,
  getPredefinedEmployeeSettingsState,
);
export const getCompanySettingsSelector = createSelector(
  getSettingsState,
  getCompanySettingsState,
);
export const getAdvancedSettingsSelector = createSelector(
  getSettingsState,
  getAdvancedSettingsState,
);
export const getBillingSettingsSelector = createSelector(
  getSettingsState,
  getBillingSettingsState,
);
export const getSettingsSelector = createSelector(
  getSettingsState,
  getIntegrationSettings,
);
